import {Alert, Box, Button, Container, FormControl, FormLabel, Stack, styled, Tab, Tabs, Typography} from "@mui/material";
import {useState} from "react";
import TabPanel from "../common/tabPanel";
import SkyBlueWrapper from "../../theme/components/SkyBlueWrapper";
import CustomInput from "../../theme/components/CustomInput";
import UploadModal from "../common/uploadModal";
import {useUser} from "../../lib/hooks";
import {Link, useNavigate} from "react-router-dom";

const QuickAccess = () => {

    const [tabIndex, setTabIndex] = useState(0);
    const [enteredLink, setEnteredLink] = useState('');
    const navigate = useNavigate();
    const user = useUser();

    const handleChangeTab = (e, newValue) => {
        setTabIndex(newValue);
    }

    return (
        <>
            <Container>
                <Typography variant="h6">امکان آپلود سریع</Typography>
            </Container>
            <SkyBlueWrapper id="quick-access" mt={2} py={{xs: 2.5, lg: 5}}>
                <Container>
                    <Box width={1} display="flex" alignItems="center" justifyContent="center">
                        <StyledTabs value={tabIndex} onChange={handleChangeTab} centered>
                            <Tab label="آپلود فایل"/>
                            <Tab label="مشاهده اشتراک گذاری"/>
                        </StyledTabs>
                    </Box>
                    <Box mt={2.5}>
                        {/* Upload Panel */}
                        <TabPanel value={tabIndex} index={0}>
                            <UploadModal/>
                        </TabPanel>
                        {/* Share Panel */}
                        <TabPanel value={tabIndex} index={1}>
                            <FormControl component='form' onSubmit={(e) => {e.preventDefault(); navigate(`/share/${enteredLink}`)}} sx={{ width: 1, display: "flex", alignItems: "center", flexDirection: {xs: "column", lg: "row"} }}>
                                <FormLabel sx={{ mb: 1, fontSize: ".975rem", color: "inherit!important"}}>برای دسترسی به یک اشتراک گذاری کد آنرا وارد کنید:</FormLabel>
                                <CustomInput
                                    value={enteredLink} onChange={(e) => setEnteredLink(e.target.value)}
                                    placeholder="کد اشتراک گذاری را وارد کنید" required
                                    sx={{ ml: {lg: 2.5}, width: {xs: "100%", lg: "40%", xl: "25%"} }}/>
                                <Button type="submit" variant="contained" sx={{ mt: {xs: 2, lg: 0}, ml: {lg: 2.5}, py: 2, px: {lg: 12}, width: {xs: "100%", lg: "auto"}, background: "#e1f5fe", color: theme => theme.palette.primary.main, "&:hover": {background: "#81d4fa"} }} disableElevation>مشاهده</Button>
                            </FormControl>
                            {!user && (
                                <Box>
                                    <Box display="flex" alignItems="center" justifyContent='center'>
                                        <Alert severity="info" sx={{ mt: 5, display: "inline-flex", width: {xs: "100%", lg: "auto"} }}>برای دسترسی به همه امکانات سایت اگر حساب میلفا دارید همینک وارد شوید و یا عضو شوید</Alert>
                                    </Box>
                                    <Box mt={1.5} display="flex" alignItems="center" justifyContent="center" color="#fff">
                                        <Link to="/drive/login">
                                            <Button color="inherit" variant="outlined" sx={{ py: 1.75, px: {lg: 12}, width: {xs: "100%", lg: "auto"} }}>ورود / ثبت نام</Button>
                                        </Link>
                                    </Box>
                                </Box>
                            )}
                        </TabPanel>
                    </Box>
                </Container>
            </SkyBlueWrapper>
        </>
    )
}
export default QuickAccess;

const StyledTabs = styled(Tabs)(({theme}) => ({
    display: "inline-flex",
    width: "100%",
    background: theme.palette.background.box,
    borderRadius: 8,
    padding: "8px 24px",
    [theme.breakpoints.up('lg')]: {
        width: "auto"
    }
}));


